import React from "react";
import SVG from "react-inlinesvg";
import LocalConvenienceStoreTwoToneIcon from "@material-ui/icons/LocalConvenienceStoreTwoTone";
import SportsVolleyballTwoToneIcon from "@material-ui/icons/SportsVolleyballTwoTone";
import ReceiptTwoToneIcon from "@material-ui/icons/ReceiptTwoTone";
import KitchenTwoToneIcon from "@material-ui/icons/KitchenTwoTone";
import MonetizationOnTwoToneIcon from "@material-ui/icons/MonetizationOnTwoTone";
import SportsTwoToneIcon from "@material-ui/icons/SportsTwoTone";
import EqualizerTwoToneIcon from "@material-ui/icons/EqualizerTwoTone";
import AccessTimeTwoToneIcon from "@material-ui/icons/AccessTimeTwoTone";
import PlaylistAddCheckTwoToneIcon from "@material-ui/icons/PlaylistAddCheckTwoTone";
import CreditCardTwoToneIcon from "@material-ui/icons/CreditCardTwoTone";
import PeopleAltTwoToneIcon from "@material-ui/icons/PeopleAltTwoTone";
import FingerprintTwoToneIcon from '@material-ui/icons/FingerprintTwoTone';

import { toAbsoluteUrl } from "../../../../_helpers";

export const MenuIcons = (iconUrl) => {
  iconUrl = iconUrl.toLowerCase();
  let iconKey = "";

  // console.log(iconUrl);

  if (iconUrl.startsWith("mui:")) {
    iconKey = iconUrl.replace("mui:", "");
    // console.log(iconKey);

    if (iconKey === "salon") return <LocalConvenienceStoreTwoToneIcon />;
    else if (iconKey === "sport") return <SportsVolleyballTwoToneIcon />;
    else if (iconKey === "price") return <MonetizationOnTwoToneIcon />;
    else if (iconKey === "contract") return <ReceiptTwoToneIcon />;
    else if (iconKey === "teacher") return <SportsTwoToneIcon />;
    else if (iconKey === "subgroup") return <PeopleAltTwoToneIcon />;
    else if (iconKey === "sans") return <AccessTimeTwoToneIcon />;
    else if (iconKey === "report") return <EqualizerTwoToneIcon />;
    else if (iconKey === "closet") return <KitchenTwoToneIcon />;
    else if (iconKey === "credit") return <CreditCardTwoToneIcon />;
    else if (iconKey === "reserve") return <PlaylistAddCheckTwoToneIcon />;
    else if (iconKey === "fingerprint") return <FingerprintTwoToneIcon />;
  } else {
    return <SVG src={toAbsoluteUrl(iconUrl)} />;
  }
};
